<!-- 活跃用户统计管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <h1 class="titleStyle">活跃用户统计管理</h1> -->
      <el-row class="top-first-line">
        <el-col :span="4">
            <el-form-item label="统计周期：">
              <el-select v-model="Dform.typeValue" filterable >
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                 >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col >
      </el-row>
    </div>
    
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         stripe
          :border="true"
         v-loading="loading"
         class="table-Style"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="totalUser"
            label="会员总数"
            >
          </el-table-column>
          <el-table-column
            prop="activeUser"
            label="活跃会员数"
            >
          </el-table-column>
          <el-table-column
          prop="totalDevice"
          label='终端总数'
          >
          </el-table-column>
          <el-table-column
            prop="activeDevice"
            label="活跃终端数"
            >
          </el-table-column>
          <el-table-column
            prop="activeCall"
            label="通话终端数"
            >
          </el-table-column >
          <el-table-column
            prop="totalPointGps"
            label="GPS点数"
            >
          </el-table-column >
          <el-table-column
            prop="totalPointLbs"
            label="基站点数"
            >
          </el-table-column>
          <el-table-column
            prop="totalPointLbsMulti"
            label="混合点数"
            >
          </el-table-column>
          <el-table-column
            prop="statisticsTime"
            label="统计周期"
            >
          </el-table-column>
         
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { activeUser } from '@/assets/api/logapi'

export default {
  components: {
  },
  data () {
    return {
      tableData: [],
      loading:true,
      options: [{
          value: '0',
          label: '日'
        }, {
          value: '1',
          label: '周'
        },{
          value: '2',
          label: '月'
        },
        {
          value: '3',
          label: '年'
        }
      ],
      Dform: {
        typeValue: '0',
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      total: 0
    }
  },
  created() {
    this.activeUserClick()
  },
  watch: {
    'Dform.typeValue' (val) {
      this.activeUserClick()
    },
  },  
  methods: {
    inquiryClick( ) {
    },
    activeUserClick () {
      let params = {
        type: this.Dform.typeValue,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      activeUser(params).then((res)=> {
        console.log(this.tableData,res,'设备管理报表接口');
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleSizeChange (val) {
      console.log(`${val} items pr page`)
    },
    handleCurrentChange (val) {
      // console.log(`分页: ${val}`)
      this.pageInfo.page = val
      this.activeUserClick()

    },
  },
  filters: {
    // hanzi (val) {
    // if( val(/^[\u4E00-\u9FA5]{1,}$/) ){
    //   return alert('汉字');
    //   }else{
    //   return alert('其他');
    //   } 
    //}
  }
}
</script>

<style lang='scss' scoped>
.fuzzy-matching-box {
  width: 100%;
  height:  95%;
  .fuzzy-matching-top {
    height: 100px ;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    align-content: space-around;  
    align-items: center;
    .titleStyle{
      margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 85%;
    }
   
      :deep() {
    
        .el-input--small .el-input__wrapper{
              margin-right: 100px;
              border-radius: 15px
              ;
            }

        .el-col-4{
          margin-top: 20px;
          color: black;
        }
        // .el-select .el-input__wrapper{
        //   // border: solid 1px;
        // }
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
       
        .el-form-item--small .el-form-item__label {
          width: 120px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
          font-weight: 700;
        }
        .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
          .el-select .el-input__inner {
            width: 100px;
          }
        .el-input {
          // color: black;
          width: 45%;
          height: 35px;
          // width: 50px;
        }
      }
      
      :deep() {
      .el-select--small .el-select__wrapper{
        width: 200px;
        height: 35px;
        border-radius: 15px
            ;
        
      }
      .el-range-editor--small.el-input__wrapper {
        height: 35px;
        line-height: 35px;  
      }
    
    }
  }
  .fuzzy-matching-bottom {
    height:85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
    .table-Style{
      font-size: 16px;
      // border-radius: 15px;
    }
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 16px;
          color: black;

        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-weight: 700;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
  
}
</style>


